module.exports = __webpack_public_path__ + "img/offer-cams.affb69aa.jpg";